import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogTitle, MenuItem } from '@mui/material';
import {
    cancelBtnStyle,
    dialogActions,
    dialogTitle,
    normalWhiteSpace,
    yesBtnStyle,
} from '../styles/UpcommingAppointments';

export const AppointmentCancellationMenuItem = ({ controller, row }) => {
    const action = controller.getAction(row);
    if (!action.visible) return null;
    return (
        <MenuItem
            disabled={action.disabled}
            onClick={action.disabled ? undefined : () => controller.beginAction(row)}
            sx={normalWhiteSpace}
        >
            {action.label}
        </MenuItem>
    );
};

export const AppointmentCancellationDialog = ({ controller }) => (
    <Dialog open={controller.isConfirmationOpen} onClose={controller.closeConfirmation}>
        <DialogTitle sx={dialogTitle}>Are you sure you want to cancel the appointment ?</DialogTitle>
        <DialogActions sx={dialogActions}>
            <Button disabled={controller.isCancelling} sx={cancelBtnStyle} onClick={controller.closeConfirmation}>
                Cancel
            </Button>
            <Button disabled={controller.isCancelling} type='submit' sx={yesBtnStyle} onClick={controller.confirmCancellation}>
                {controller.isCancelling ? 'Cancelling...' : 'Yes'}
            </Button>
        </DialogActions>
    </Dialog>
);

const controllerShape = PropTypes.shape({
    beginAction: PropTypes.func.isRequired,
    closeConfirmation: PropTypes.func.isRequired,
    confirmCancellation: PropTypes.func.isRequired,
    getAction: PropTypes.func.isRequired,
    isCancelling: PropTypes.bool.isRequired,
    isConfirmationOpen: PropTypes.bool.isRequired,
}).isRequired;

AppointmentCancellationMenuItem.propTypes = {
    controller: controllerShape,
    row: PropTypes.shape({
        Status: PropTypes.string,
        appointment_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        dentally: PropTypes.object,
    }).isRequired,
};

AppointmentCancellationDialog.propTypes = { controller: controllerShape };
